import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';
import type { CreateLeadStageDto, LeadStage } from '@/types/lead';

export function useCreateLeadStage() {
  const queryClient = useQueryClient();

  return useApiMutation<LeadStage, CreateLeadStageDto>({
    mutationFn: (dto) =>
      apiPost<LeadStage, CreateLeadStageDto>(operationsClient, leadEndpoints.stages(), dto),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.stages() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead stage created');
    },
  });
}
